
import { MathBase } from "@goodgamestudios/core";
import { TextFieldHelper } from "@goodgamestudios/core";
import { getDefinitionByName } from "@goodgamestudios/createjs-utilities";
import { int } from "@goodgamestudios/math-utilities";
import { AchievementsVO } from "../../../gamevo/AchievementsVO";
import { Poker2Model } from "../../../model/Poker2Model";
import { Poker2MouseWheelUpDown } from "../Poker2MouseWheelUpDown";

import { NumberStringHelper } from "../../../helper/NumberStringHelper";

import MovieClip = createjs.MovieClip;
import MouseEvent = createjs.MouseEvent;
import Rectangle = createjs.Rectangle;
import {Poker2LayoutManager} from "../../Poker2LayoutManager";

export class Poker2ProfilTabAchievement {
    private disp: MovieClip; //profilDialog.mc_achievement
    private mouseWheelUpDown: Poker2MouseWheelUpDown;
    private currentPage: number = 0;
    private maxPage: number = 0;
    private NUM_ACHIEVEMENTS: number = 8;
    private MAX_ITEM_WIDTH: number = 60;
    private MAX_ITEM_HEIGHT: number = 60;
    private static PROGRESS_BAR_RANGE: number = 149;

    constructor(disp: MovieClip) {
        this.disp = disp;
        this.mouseWheelUpDown = new Poker2MouseWheelUpDown();
    }

    public applyProperties(): void {
        this.disp.txt_title.text = Poker2Model.languageData.getTextById("menu_btn_achievements");
        this.disp.txt_earnpoints_info.text = Poker2Model.languageData.getTextById("userprofil_achievement_earnpoints");
        this.disp.txt_earnpoints_info.width = this.disp.txt_earnpoints_info.textWidth + 10;
        this.disp.txt_totalpoints_info.text = Poker2Model.languageData.getTextById("userprofil_achievement_totalpoints");
        this.disp.txt_totalpoints_info.width = this.disp.txt_totalpoints_info.textWidth + 10;
        this.mouseWheelUpDown.init(this.disp.btn_up, this.disp.btn_down, this.disp);
    }

    public show(): void {
        var maxValueX: number = int(MathBase.max(this.disp.txt_earnpoints_info.x + this.disp.txt_earnpoints_info.width, this.disp.txt_totalpoints_info.x + this.disp.txt_totalpoints_info.width));
        this.disp.txt_earnpoints_value.x = maxValueX + 5;
        this.disp.txt_totalpoints_value.x = maxValueX + 5;
        this.mouseWheelUpDown.activateMouseWheel();
    }

    public hide(): void {
        this.mouseWheelUpDown.deactivateMouseWheel();
    }

    public destroy(): void {
        this.mouseWheelUpDown.destroy();
    }

    public onClick(event: MouseEvent): void {
        switch (event.target) {
            case this.disp.btn_up:
                this.changeAchievementPage(MathBase.max(0, this.currentPage - 1));
                break;
            case this.disp.btn_down:
                this.changeAchievementPage(MathBase.min(this.maxPage, this.currentPage + 1));
                break;
        }
    }

    public changeAchievementPage(page: number): void {
        this.currentPage = page;
        this.drawAchievements();
        this.disp.txt_earnpoints_value.text = Poker2Model.achievementData.achievementLevels + "/" + Poker2Model.achievementData.achievementMaxLevels;
        this.disp.txt_totalpoints_value.text = String(Poker2Model.achievementData.achievementPoints);
    }

    private initArrows(nofItems: number): void {
        this.maxPage = int((nofItems - 1) / this.NUM_ACHIEVEMENTS);
        this.disp.btn_down.visible = this.disp.btn_up.visible = (this.maxPage > 0);
        this.disp.btn_down.enableButton = (this.maxPage > 0 && this.currentPage < this.maxPage);
        this.disp.btn_up.enableButton = (this.maxPage > 0 && this.currentPage > 0);
    }

    private drawAchievements(): void {
        var startPos: number = this.currentPage * this.NUM_ACHIEVEMENTS;
        var achievementArray: any[] = Poker2Model.achievementData.achievementArray;

        this.initArrows(achievementArray.length);

        for (var i: number = startPos; i < startPos + this.NUM_ACHIEVEMENTS; i++) {
            var currentItem: number = i - startPos;
            var achievementContainer: Library.PokerInterface.Achievement_Item = this.disp["i" + currentItem] as Library.PokerInterface.Achievement_Item;

            if (i < achievementArray.length) {
                var achievement: AchievementsVO = achievementArray[i];
                achievementContainer.mouseChildren = false;
                achievementContainer.txt_name.text = Poker2Model.languageData.getTextById(achievement.getVisClassName());
                achievementContainer.txt_level.text = NumberStringHelper.groupString(achievement.currentLevel, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));

                var amountText: string;

                if (achievement.currentLevel >= achievement.maxLevel)
                    amountText = NumberStringHelper.groupString(achievement.amount, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData));
                else
                    amountText = Poker2Model.languageData.getTextById("xofy", [NumberStringHelper.groupString(achievement.amount, Poker2Model.languageData.getTextById.bind(Poker2Model.languageData)), NumberStringHelper.groupString(Poker2Model.achievementData.getAmountToLevel(achievement, achievement.currentLevel + 1), Poker2Model.languageData.getTextById.bind(Poker2Model.languageData))]);

                achievementContainer.mc_progress.mc_mask.x = achievementContainer.mc_progress.mc_mask.width * Poker2Model.achievementData.getAmountToNextLevelInPercent(achievement);
                achievementContainer.mc_progress.doCache();
                achievementContainer.mc_progress.x = -224;
                achievementContainer.mc_progress.y = 18;

                achievementContainer.txt_copy.text = Poker2Model.languageData.getTextById(achievement.getVisClassName() + "_copy");
                TextFieldHelper.changeTextFromatSizeByTextWidth(9, achievementContainer.txt_amount, amountText);

                var mcClass: any = getDefinitionByName(achievement.getVisClassName()) as any;
                var achievementMC: MovieClip = new mcClass();
                var bounds: Rectangle = achievementMC.getBounds(null);

                var scaleFactor: number = (this.MAX_ITEM_WIDTH / bounds.width);

                if ((bounds.height * scaleFactor) > this.MAX_ITEM_HEIGHT) {
                    scaleFactor = (this.MAX_ITEM_HEIGHT / bounds.height);
                }

                achievementMC.scaleX = achievementMC.scaleY = scaleFactor;
                achievementMC.x = -((bounds.width * scaleFactor) / 2 + (bounds.left * scaleFactor));
                achievementMC.y = -((bounds.height * scaleFactor) / 2 + (bounds.top * scaleFactor));

                while (achievementContainer.mc_achievementholder.numChildren > 0) {
                    achievementContainer.mc_achievementholder.removeChildAt(0);
                }
                achievementContainer.mc_achievementholder.addChild(achievementMC);
                achievementContainer.visible = true;
            }
            else
                achievementContainer.visible = false;
        }
    }
}
